import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Toggle, Flex } from "@unifize/sarah";
import { SingleSelect } from "src/components/Unifize";

import { getDynamicFilters } from "src/api/workflow";
import { FieldId, DynamicWorkflowFilter } from "src/types";

type Props = {
  fieldId: FieldId;
  settings: Object;
  filter: Object;
  setFilter: (settings: Object) => void;
};

const DynamicRecord: React.FC = ({
  fieldId,
  settings,
  filter,
  setFilter,
}: Props) => {
  const currentWorkflowId = useSelector((state) => state.location.payload.id);

  const [checked, setChecked] = useState(false);
  const [dynamicFields, setDynamicFields] = useState<Array<Object>>([]);

  const handleSelect = (selected: FieldId) => {
    const selectedFilter = dynamicFields.find(
      (item) => item.relatedCid === selected,
    );

    if (!selectedFilter) return;

    const { linkedCid, relatedCid } = selectedFilter;

    setFilter({ linkedCid, relatedCid });
  };

  const handleToggle = (value: boolean) => {
    setChecked(value);

    // Clear selected filter when settings is turned off
    if (value === false) {
      setFilter(null);
    }
  };

  useEffect(() => {
    // Fetch dynamic filters when component mounts
    getDynamicFilters({
      currentWorkflowId,
      fieldWorkflowId: settings.workflow,
    })
      .then((filters) => {
        setDynamicFields(filters);
      })
      .catch((error) => {
        console.error("Unable to fetch dynamic filters", error);
        setDynamicFields([]);
      });

    // Set checkbox to checked by default if already selected
    if (settings.dynamicFilter !== null) {
      setChecked(true);
    }
  }, []);

  if (dynamicFields.length === 0 && !checked) return null;

  return (
    <Flex direction="column" gap={4}>
      <Toggle
        checked={checked}
        onChange={handleToggle}
        size="small"
        labelPlacement="start"
        label="Link to another linked record"
      />
      {checked && (
        <SingleSelect
          data={dynamicFields}
          keys={["relatedCid", "relatedLabel"]}
          onChange={handleSelect}
          selected={filter?.relatedCid}
          placeholder="Select field"
        />
      )}
    </Flex>
  );
};

export default DynamicRecord;
